import api from '../../api'

export default {
  state: () => ({
    team: null,
    teamUsers: [],
    allTeams: [],
  }),
  getters: {
    gameTeam: state => state.team,
    gameAllTeams: state => state.allTeams,
    myTeamUsers: state => state.teamUsers,
  },
  actions: {
    async fetchAllTeams({ commit, getters }) {
      try {
        const { data } = await api.team.findAllForGame(getters.activeGame.id)
        commit('SET_ALL_TEAMS', data)
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
    },
    async fetchTeam({ commit, getters }) {
      try {
        const { data } = await api.team.findDetail(getters.myTeam.id)
        commit('SET_TEAM', data)
        commit('SET_TEAM_USERS', data.users)
      } catch (e) {
        //this.$toast.error('Something went wrong!');
      }
    },
    async addTeamMoney({ commit, getters }, money) {
      commit('SET_TEAM_MONEY', getters.gameTeam.money + money)
    },
    async changeTeamAds({ commit, getters }, adsChange) {
      var change = 0;
      if (getters.gameTeam.adCountCurrentTurn + adsChange > 0) {
        change = getters.gameTeam.adCountCurrentTurn + adsChange;
      }
      commit('SET_TEAM_ADS', change)
    },
    async deleteTeam({ dispatch }, id) {
      dispatch('toggleLoader', true)
      try {
        await api.team.delete(id)
        dispatch('toggleLoader', false)
        return true
      } catch (e) {
        this.$toast.error('Something went wrong!');
      }
      dispatch('toggleLoader', false)
      return false
    }
  },
  mutations: {
    SET_TEAM(state, data) {
      state.team = data
    },
    SET_TEAM_USERS(state, data) {
      state.teamUsers = data
    },
    SET_ALL_TEAMS(state, data) {
      state.allTeams = data
    },
    SET_TEAM_MONEY(state, money) {
      state.team = { ...state.team, money }
    },
    SET_TEAM_ADS(state, adCountCurrentTurn) {
      state.team = { ...state.team, adCountCurrentTurn }
    },
  },
}
